import React, { useState } from "react";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import TopBanner from "../components/TopBanner/TopBanner";
import { Spin } from "antd";
import BlogListingNav from "../components/BlogListing/BlogListingNav";
import BlogListingFooter from "../components/BlogListing/BlogListingFooter";

const MainLayout = ({ children, loader, showBlogNav = false }) => {
  const [showTopBanner, setShowTopBanner] = useState(true);
  // const contentStyle = {
  //   padding: 50,
  //   background: "rgba(0, 0, 0, 0.05)",
  //   borderRadius: 4,
  // };
  return (
    <>
      {loader ? (
        <div
          style={{
            height: "100vh",
            overflow: "hidden",
            background: "rgb(9, 13, 36)",
          }}
        >
          <Spin fullscreen size="large" />
        </div>
      ) : (
        <div className="container-fluid m-0 p-0">
          {/* {!showBlogNav && showTopBanner && (
            <TopBanner setShowTopBanner={setShowTopBanner} />
          )} */}
          {showBlogNav ? <BlogListingNav /> : <Navbar />}
          <div>{children}</div>
          {showBlogNav ? <BlogListingFooter /> : <Footer />}
        </div>
      )}
    </>
  );
};

export default MainLayout;
